/**
 * Loads all required data files
 */
export async function loadData() {
  try {
    console.log('Loading data files...');

    const [corpus1, corpus2, locations] = await Promise.all([
      fetch('./data/corpus-metadata-1.json')
        .then(r => {
          if (!r.ok) throw new Error(`corpus-metadata-1.json: ${r.status}`);
          return r.json();
        })
        .catch(e => {
          console.error('Error loading corpus-metadata-1.json:', e);
          return [];
        }),
      fetch('./data/corpus-metadata-2.json')
        .then(r => {
          if (!r.ok) throw new Error(`corpus-metadata-2.json: ${r.status}`);
          return r.json();
        })
        .catch(e => {
          console.error('Error loading corpus-metadata-2.json:', e);
          return [];
        }),
      fetch('./data/locations.json')
        .then(r => {
          if (!r.ok) throw new Error(`locations.json: ${r.status}`);
          return r.json();
        })
        .catch(e => {
          console.error('Error loading locations.json:', e);
          return {};
        })
    ]);

    console.log('Data loaded successfully');
    console.log(`- Corpus 1: ${Array.isArray(corpus1) ? corpus1.length : 'invalid'} items`);
    console.log(`- Corpus 2: ${Array.isArray(corpus2) ? corpus2.length : 'invalid'} items`);
    console.log(`- Locations: ${Object.keys(locations).length} entries`);

    return {
      corpus1,
      corpus2,
      locations
    };
  } catch (error) {
    console.error('Error loading data:', error);
    throw new Error('Failed to load one or more data files');
  }
}

/**
 * Expected data formats:
 *
 * corpus-metadata-1.json / corpus-metadata-2.json:
 * [
 *   {
 *     "id": "item-001",
 *     "year": 1650,
 *     "locations": ["loc-stockholm-001", "loc-uppsala-001", ...]
 *   },
 *   ...
 * ]
 *
 * locations.json:
 * {
 *   "loc-stockholm-001": {
 *     "name": "Stockholm",
 *     "display_name": "Stockholm, Sweden",
 *     "type": "city",
 *     "lat": 59.3293,
 *     "lon": 18.0686,
 *     "boundingbox": [59.1, 59.5, 17.8, 18.4]  // Optional for regions
 *   },
 *   ...
 * }
 */
